import React from "react";
import { compose, withProps } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  Polygon,
} from "react-google-maps";

let mapOptions = {
  zoomControl: true,
  cameraControl: false,
};
const MyMapComponent = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${process.env.NEXT_PUBLIC_GOOGLE_API}&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `300px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)((props) => (
  <GoogleMap
    defaultZoom={14}
    options={mapOptions}
    defaultCenter={{ lat: parseFloat(props.lat), lng: parseFloat(props.lang) }}
  >
    {props.isMarkerShown && (
      <Marker
        position={{ lat: parseFloat(props.lat), lng: parseFloat(props.lang) }}
        onClick={props.onMarkerClick}
      />
    )}
    <Polygon
      path={getpolygons(props.poly)}
      options={{
        fillColor: getcolor(props.npiscore),
        strokeColor: "#5000ff",
        strokeWeight: 1,
      }}
      onClick={() => {
        window.open("/Neighborhood/?id=" + props.neighborid, "_blank");
      }}
    />
  </GoogleMap>
));
function getpolygons(data) {
  if (data) {
    const x = data.map((item) => {
      return { lat: item.x, lng: item.y };
    });
    return x;
  }
}

function getcolor(value) {
  let color = "";

  if (parseFloat(value) >= 0.9) {
    color = "#006600";
  } else if (parseFloat(value) >= 0.8) {
    color = "#006600";
  } else if (parseFloat(value) >= 0.7) {
    color = "#00b300";
  } else if (parseFloat(value) >= 0.6) {
    color = "#1aff1a";
  } else if (parseFloat(value) >= 0.5) {
    color = "#ffff00";
  } else if (parseFloat(value) >= 0.4) {
    color = "#ffa64d";
  } else if (parseFloat(value) >= 0.3) {
    color = "#ffa64d";
  } else if (parseFloat(value) >= 0.2) {
    color = "#ff4000";
  } else {
    color = "#00FF00";
  }
  return color;
}

class Map extends React.PureComponent {
  constructor(props) {
    super(props);
  }
  state = {
    isMarkerShown: false,
  };

  componentDidMount() {
    this.delayedShowMarker();
  }

  delayedShowMarker = () => {
    setTimeout(() => {
      this.setState({ isMarkerShown: true });
    }, 1000);
  };

  handleMarkerClick = () => {
    this.setState({ isMarkerShown: false });
    this.delayedShowMarker();
  };

  render() {
    return (
      <MyMapComponent
        isMarkerShown={this.state.isMarkerShown}
        //onMarkerClick={this.handleMarkerClick}
        lat={this.props.lat}
        lang={this.props.lang}
        poly={this.props.poly_data}
        neighborid={this.props.neighbor_id}
        npiscore={this.props.npiscore}
      />
    );
  }
}

export default Map;
